import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useT } from '../contexts/LocaleContext.jsx';

const StripeIncompleteRedirect = () => {
  const navigate = useNavigate();
  const t = useT();
  const [searchParams] = useSearchParams();
  const bandId = searchParams.get('band_id');

  useEffect(() => {
    if (bandId) {
      // Redirect to the band's page with payment setup view and error message.
      // Router state carries the catalog key, not the text, so the band page
      // translates it in whatever locale is active when it renders.
      navigate(`/performers/${bandId}`, {
        state: {
          showPaymentSetup: true,
          paymentMessage: {
            type: 'error',
            key: 'performer.paymentMessages.stripeIncomplete'
          }
        }
      });
    } else {
      // If no band_id, redirect to home
      navigate('/home');
    }
  }, [bandId, navigate]);

  // Show a loading message while redirecting
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      color: 'var(--main-content-text-color)'
    }}>
      <p>{t('app.redirect.redirecting')}</p>
    </div>
  );
};

export default StripeIncompleteRedirect;